/* eslint-disable no-undef */
import $ from 'jquery';

interface CallObject {
    url: string;
    callback: Function;
}

export class DynamicCalls {
    private _calls: Array<CallObject>;

    public constructor() {
        this._calls = [];
    }

    public add(data: CallObject) {
        this._calls.push(data);
    }

    public async execute() {
        for (const call of this._calls) {
            await this._request(call);
        }
    }

    private _request(data: CallObject) {
        if (!data) {
            return;
        }

        return $.getJSON(data.url)
            .done(function (response) {
                data.callback(response);
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                console.log('DynamicCalls._request error:' + textStatus);
            });

    }
}
